import React, { useState } from 'react';
import AchievementToast from './AchievementToast';
import LevelUpNotification from './LevelUpNotification';

function AchievementDebug() {
  const [playerName, setPlayerName] = useState('Player');
  const [toastData, setToastData] = useState(null);
  const [levelData, setLevelData] = useState(null);
  const [multipleToasts, setMultipleToasts] = useState([]);

  const showLevelUp = () => {
    const level = 3;
    const bonusPoints = level * 10;
    setLevelData({ level, bonusPoints, playerName });

    // Get actual player data if available
    const selectedPlayerIds = JSON.parse(
      localStorage.getItem('selectedPlayerIds') || '[]'
    );
    const allPlayersData = JSON.parse(
      localStorage.getItem('allPlayersData') || '[]'
    );
    let displayName = playerName;

    if (selectedPlayerIds.length > 0 && allPlayersData.length > 0) {
      const player = allPlayersData.find((p) =>
        selectedPlayerIds.includes(p.playerId)
      );
      if (player) {
        displayName = `${player.avatar || '👤'} ${player.playerName}`;
      }
    }

    setToastData({
      achievement: {
        levelUp: true,
        message: `Level ${level} unlocked! +${bonusPoints} bonus points!`,
      },
      playerName: displayName,
    });
  };

  const showStreak = () => {
    // Get actual player data if available
    const selectedPlayerIds = JSON.parse(
      localStorage.getItem('selectedPlayerIds') || '[]'
    );
    const allPlayersData = JSON.parse(
      localStorage.getItem('allPlayersData') || '[]'
    );
    let displayName = playerName;

    if (selectedPlayerIds.length > 0 && allPlayersData.length > 0) {
      const player = allPlayersData.find((p) =>
        selectedPlayerIds.includes(p.playerId)
      );
      if (player) {
        displayName = `${player.avatar || '👤'} ${player.playerName}`;
      }
    }

    setToastData({
      achievement: {
        type: 'streak',
        name: '7-Day Streak!',
        message: 'Amazing! A whole week!',
      },
      playerName: displayName,
    });
  };

  const showPointsMilestone = () => {
    // Get actual player data if available
    const selectedPlayerIds = JSON.parse(
      localStorage.getItem('selectedPlayerIds') || '[]'
    );
    const allPlayersData = JSON.parse(
      localStorage.getItem('allPlayersData') || '[]'
    );
    let displayName = playerName;

    if (selectedPlayerIds.length > 0 && allPlayersData.length > 0) {
      const player = allPlayersData.find((p) =>
        selectedPlayerIds.includes(p.playerId)
      );
      if (player) {
        displayName = `${player.avatar || '👤'} ${player.playerName}`;
      }
    }

    setToastData({
      achievement: {
        type: 'points',
        name: '500 Points!',
        message: "Wow! You're getting so strong!",
      },
      playerName: displayName,
    });
  };

  const showGeneric = () => {
    // Get actual player data if available
    const selectedPlayerIds = JSON.parse(
      localStorage.getItem('selectedPlayerIds') || '[]'
    );
    const allPlayersData = JSON.parse(
      localStorage.getItem('allPlayersData') || '[]'
    );
    let displayName = playerName;

    if (selectedPlayerIds.length > 0 && allPlayersData.length > 0) {
      const player = allPlayersData.find((p) =>
        selectedPlayerIds.includes(p.playerId)
      );
      if (player) {
        displayName = `${player.avatar || '👤'} ${player.playerName}`;
      }
    }

    setToastData({
      achievement: {
        type: 'generic',
        name: 'Badge Unlocked',
        message: 'You earned a special badge!',
      },
      playerName: displayName,
    });
  };

  const showMultipleAchievements = () => {
    // Get players from localStorage
    const selectedPlayerIds = JSON.parse(
      localStorage.getItem('selectedPlayerIds') || '[]'
    );

    console.log('Selected player IDs:', selectedPlayerIds);

    if (selectedPlayerIds.length === 0) {
      alert('No players selected. Please select players first.');
      return;
    }

    // Try to get actual player data from localStorage
    let selectedPlayers = [];

    // Check if we have allPlayersData in localStorage
    const allPlayersData = JSON.parse(
      localStorage.getItem('allPlayersData') || '[]'
    );
    if (allPlayersData.length > 0) {
      selectedPlayers = allPlayersData.filter((player) =>
        selectedPlayerIds.includes(player.playerId)
      );
    }

    // If no allPlayersData, create mock data with player IDs
    if (selectedPlayers.length === 0) {
      selectedPlayers = selectedPlayerIds.map((playerId, index) => ({
        playerId: playerId,
        playerName: `Player ${index + 1}`,
        avatar: ['🐶', '🐱', '🐰', '🐼', '🐨', '🦊', '🐯', '🦁'][index % 8], // Default emojis
      }));
    }

    console.log(
      'Triggering multiple achievements for players:',
      selectedPlayers
    );

    // Create achievement queue
    const achievements = [
      {
        type: 'level',
        name: 'Level Up!',
        message: `Level ${Math.floor(Math.random() * 5) + 1} unlocked! +${
          Math.floor(Math.random() * 50) + 10
        } bonus points!`,
        levelUp: true,
      },
      {
        type: 'streak',
        name: '7-Day Streak!',
        message: 'Amazing! A whole week!',
      },
      {
        type: 'points',
        name: '500 Points!',
        message: "Wow! You're getting so strong!",
      },
      {
        type: 'generic',
        name: 'Badge Unlocked',
        message: 'You earned a special badge!',
      },
    ];

    const queue = selectedPlayers.map((player, index) => ({
      achievement: achievements[index % achievements.length],
      playerName: `${player.avatar || '👤'} ${player.playerName}`,
    }));

    setMultipleToasts(queue);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Achievement UI Debugger</h2>
      <div style={{ marginBottom: 12 }}>
        <label style={{ marginRight: 8 }}>Player name</label>
        <input
          type='text'
          value={playerName}
          onChange={(e) => setPlayerName(e.target.value)}
          style={{
            padding: '6px 8px',
            borderRadius: 6,
            border: '1px solid #ccc',
          }}
        />
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <button className='button button-primary' onClick={showLevelUp}>
          Show Level Up
        </button>
        <button className='button button-secondary' onClick={showStreak}>
          Show Streak Milestone
        </button>
        <button className='button' onClick={showPointsMilestone}>
          Show Points Milestone
        </button>
        <button className='button' onClick={showGeneric}>
          Show Generic Achievement
        </button>
        <button
          className='button button-primary'
          onClick={showMultipleAchievements}
          style={{ backgroundColor: '#ff6b6b' }}
        >
          🎉 Multiple Achievements (from localStorage)
        </button>
      </div>

      {levelData && (
        <LevelUpNotification
          level={levelData.level}
          bonusPoints={levelData.bonusPoints}
          playerName={levelData.playerName}
          onClose={() => setLevelData(null)}
        />
      )}

      {toastData && (
        <AchievementToast
          achievement={toastData.achievement}
          playerName={toastData.playerName}
          onClose={() => setToastData(null)}
          autoDismissTime={10000}
        />
      )}

      {/* Multiple toasts */}
      <div
        style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 3000,
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        {multipleToasts.map((toast, index) => (
          <AchievementToast
            key={`${toast.playerName}-${index}`}
            achievement={toast.achievement}
            playerName={toast.playerName}
            onClose={() => {
              setMultipleToasts((prev) => prev.filter((_, i) => i !== index));
            }}
            autoDismissTime={10000}
          />
        ))}
      </div>
    </div>
  );
}

export default AchievementDebug;
